<template>
  <transition name="drawer-fade">
    <div v-if="isVisible" class="drawer-overlay" @click="closeDrawer"></div>
  </transition>
  
  <transition name="drawer-slide">
    <div v-if="isVisible" class="drawer-panel">
      <div class="drawer-header">
        <h2 class="drawer-title">{{ feature?.title }}</h2>
        <button class="drawer-close" @click="closeDrawer">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      
      <div class="drawer-content" v-if="feature">
        <!-- 能力定义 -->
        <div class="section-block">
          <p class="section-description">{{ feature.description }}</p>
        </div>

        <!-- 核心功能 -->
        <div class="section-block">
          <h3 class="section-title">{{ $t('featuresSection.modalCoreFunc') }}</h3>
          <ul class="bullet-list">
            <li v-for="(func, index) in feature.functionalities" :key="index">
              <span class="bullet-icon">→</span>
              {{ func }}
            </li>
          </ul>
        </div>

        <!-- 技术优势 -->
        <div class="section-block">
          <h3 class="section-title">{{ $t('featuresSection.modalTechAdvantage') }}</h3>
          <p class="section-text">{{ feature.technicalAdvantage }}</p>
        </div>

        <!-- 市场价值 -->
        <div class="section-block">
          <h3 class="section-title">{{ $t('featuresSection.modalMarketValue') }}</h3>
          <p class="section-text">{{ feature.marketValue }}</p>
        </div>

        <!-- 发展前景 -->
        <div class="section-block section-block-last">
          <h3 class="section-title">{{ $t('featuresSection.modalDevProspect') }}</h3>
          <p class="section-text">{{ feature.developmentProspect }}</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'DrawerPanel',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    feature: {
      type: Object,
      default: null
    }
  },
  methods: {
    closeDrawer() {
      this.$emit('close')
    }
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    }
  },
  beforeUnmount() {
    document.body.style.overflow = 'auto'
  }
}
</script>

<style scoped>
.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(8px);
  z-index: 9998;
}

.drawer-panel {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 520px;
  background: linear-gradient(180deg, #0B1220 0%, #0F172A 100%);
  border-left: 1px solid rgba(255, 255, 255, 0.08);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  box-shadow: -20px 0 60px rgba(0, 0, 0, 0.8);
  overflow: hidden;
}

.drawer-header {
  padding: 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  background: rgba(11, 18, 32, 0.95);
  backdrop-filter: blur(10px);
  position: sticky;
  top: 0;
}

.drawer-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #F9FAFB;
  margin: 0;
  letter-spacing: -0.3px;
}

.drawer-close {
  width: 40px;
  height: 40px;
  border: none;
  background: none;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.drawer-close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #F9FAFB;
}

.drawer-content {
  flex: 1;
  overflow-y: auto;
  padding: 2rem;
}

.drawer-content::-webkit-scrollbar {
  width: 6px;
}

.drawer-content::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.drawer-content::-webkit-scrollbar-thumb {
  background: rgba(0, 185, 255, 0.3);
  border-radius: 3px;
}

.drawer-content::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 185, 255, 0.5);
}

.section-block {
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  transition: all 0.2s ease;
}

.section-block:hover {
  background: rgba(0, 185, 255, 0.03);
  border-color: rgba(0, 185, 255, 0.15);
}

.section-block-last {
  margin-bottom: 1rem;
}

.section-description {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.8;
  margin: 0;
  font-weight: 500;
}

.section-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #00B9FF;
  margin: 0 0 1rem 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.section-text {
  font-size: 0.95rem;
  color: rgba(209, 213, 219, 0.9);
  line-height: 1.7;
  margin: 0;
}

.bullet-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.bullet-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 0.95rem;
  color: rgba(209, 213, 219, 0.9);
  line-height: 1.6;
}

.bullet-icon {
  color: #00B9FF;
  font-weight: 700;
  flex-shrink: 0;
  margin-top: 2px;
}

.drawer-fade-enter-active,
.drawer-fade-leave-active {
  transition: opacity 0.3s ease;
}

.drawer-fade-enter-from,
.drawer-fade-leave-to {
  opacity: 0;
}

.drawer-slide-enter-active,
.drawer-slide-leave-active {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.drawer-slide-enter-from,
.drawer-slide-leave-to {
  transform: translateX(100%);
}

@media (max-width: 1024px) {
  .drawer-panel {
    width: 100%;
    max-width: 520px;
  }
}

@media (max-width: 768px) {
  .drawer-panel {
    width: 100%;
    border-left: none;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
  }

  .drawer-header {
    padding: 1.5rem;
  }

  .drawer-title {
    font-size: 1.3rem;
  }

  .drawer-content {
    padding: 1.5rem;
  }

  .section-block {
    margin-bottom: 1.5rem;
    padding: 1.25rem;
  }
}
</style>
